import {Strings} from "@app/constants/strings";
import CONSTANTS from "@utils/constants";

export const RouteUrl = {
    main: {
        intro: {url: '/main', id: 'main000', name: Strings.init},
    },
    auth: {
        init: {url: '/auth', id: 'auth000', name: Strings.init},
        login: {url: '/auth/login', id: 'auth001', name: Strings.login},
        logout: {url: '/auth/logout', id: 'auth002', name: Strings.logout},
        token: {url: '/auth/token', id: 'auth003', name: Strings.login},
        krafton: {url: '/auth/krafton/sso', id: 'auth004', name: Strings.login},
        signup: {url: '/auth/signup', id: 'auth005', name: Strings.signup},
        complete: {url: '/auth/complete', id: 'auth006', name: Strings.signup},
        brandCode: {url: '/auth/init', id: 'auth007', name: Strings.brand},
        passwordChange: {url: '/auth/password-change', id: 'auth008', name: Strings.changePassword},
        passwordChangeComp: {url: '/auth/password-change/complete', id: 'auth009', name: Strings.changePassword},
    },
    land: {
        invite: {url: '/land/invite', id: 'land000', name: Strings.signup},
    },
    base: '/',
    operation: {
        dashboard: {url: '/op/dashboard', id: 'op001', name: Strings.dashboard},
        space: {
            name: Strings.spaceSetting,
            space: {url: '/op/space', id: 'op010', name: Strings.space},
            spaceDetail: {url: '/op/space/detail', id: 'op011', name: Strings.space},
        },
        personnel: {
            name: Strings.personnelManagement,
            employee: {url: '/op/employee', id: 'op020', name: Strings.employeeManagement},
        },
        statLog: {
            name: Strings.statisticsLogManagement,
            statistics: {url: '/op/statLog/statistics', id: 'op030', name: Strings.statisticsManagement},
            log: {url: '/op/statLog/log', id: 'op031', name: Strings.logManagement},
        },
        system: {
            name: Strings.systemManagement,
            remote: {url: '/op/system/remote', id: 'op040', name: Strings.remoteManagement},
            distribute: {
                url: '/op/system/distribute', id: 'op041', name: Strings.distributeManagementSpace,
                fileEdit: {url: '/op/system/distribute/file/edit', id: 'op042', name: Strings.contentsAdd},
            },
            failure: {url: '/op/system/failure', id: 'op043', name: Strings.failureNotification},
        },

        board: {
            name: Strings.board,
            notice: {url: '/op/board/notice', id: 'op050', name: Strings.notice},
            noticeEdit: {url: '/op/board/notice/edit', id: 'op051', name: Strings.notice},
            manual: {url: '/op/board/manual', id: 'op052', name: Strings.manual},
            manualEdit: {url: '/op/board/manual/edit', id: 'op053', name: Strings.manual},
        },
        setting: {
            name: Strings.setting,
            storage: {url: '/op/storage', id: 'op060', name: Strings.fileStorage}
        }
    },
    brand: {
        dashboard: {
            url: '/brand/dashboard',
            id: 'brand001',
            name: Strings.dashboard,
            company: {url: '/brand/dashboard/company', id: 'brand002', name: Strings.corporateUsageStatus},
            shop: {url: '/brand/dashboard/shop', id: 'brand003', name: Strings.shopOperationStatus},
            notice: {url: '/brand/dashboard/notice', id: 'brand004', name: Strings.notice},
            manual: {url: '/brand/dashboard/manual', id: 'brand005', name: Strings.usageManual},
        },
        personnel: {
            name: Strings.personnelManagement,
            employee: {url: '/brand/personnel/employee', id: 'brand011', name: Strings.employeeManagement},
            employeeValidate: {
                url: '/brand/personnel/employee/validate',
                id: 'brand011',
                name: Strings.employeeManagement
            },
            external: {url: '/brand/personnel/external', id: 'brand012', name: Strings.externalPeopleManagement},
            externalEdit: {
                url: '/brand/personnel/external/edit',
                id: 'brand013',
                name: Strings.externalPeopleManagement
            },
            qr: {url: '/brand/personnel/qr', id: 'brand014', name: Strings.qrEmployeeIdCardManagement}
        },
        statistics: {
            name: Strings.salesManagement,
            sale: {url: '/brand/statistics/sale', id: 'brand021', name: Strings.salesStatistics},
            employee: {url: '/brand/statistics/employee', id: 'brand022', name: Strings.employeeStatistics}
        },
        point: {
            name: Strings.pointSystem,
            setting: {url: '/brand/point/setting', id: 'brand031', name: Strings.pointSetting},
            manage: {url: '/brand/point/manage', id: 'brand032', name: Strings.pointManagement},
            historyDetail: {url: '/brand/point/manage/history', id: 'brand032', name: Strings.pointTransactionDetail},
            historyManual: {url: '/brand/point/manage/history/manual', id: 'brand032', name: Strings.pointTransactionRegister},
            historyExcelRaw: {url: '/brand/point/manage/history/excel/raw', id: 'brand032', name: Strings.pointTransactionDetailExcel},
            historyExcelMatching: {url: '/brand/point/manage/history/excel/matching', id: 'brand032', name: Strings.pointTransactionDetailExcel},
            employeeDetail: {url: '/brand/point/manage/employee', id: 'brand032', name: Strings.pointDetail},
            // use: {url: '/brand/point/use', id: 'brand033', name: Strings.useStatistics}
        },
        coupon: {
            name: Strings.couponSystem,
            base: {url: '/brand/coupon', id: 'brand041', name: Strings.couponManagement},
            use: {url: '/brand/coupon/use', id: 'brand042', name: Strings.useStatistics},
            setting: {url: '/brand/coupon/setting', id: 'brand043', name: Strings.couponSetting}
        },
        stamp: {
            name: Strings.stampSystem,
            base: {url: '/brand/stamp', id: 'brand051', name: Strings.stampManagement},
            use: {url: '/brand/stamp/use', id: 'brand052', name: Strings.useStatistics},
            setting: {url: '/brand/stamp/setting', id: 'brand053', name: Strings.couponSetting}
        },
        board: {
            name: Strings.boardManagement,
            base: {url: '/brand/board', id: 'brand061', name: Strings.board},
            edit: {url: '/brand/board/edit', id: 'brand062', name: Strings.board},
            survey: {url: '/brand/board/survey', id: 'brand063', name: Strings.survey},
            surveyEdit: {url: '/brand/board/survey/edit', id: 'brand065', name: Strings.survey},
            terms: {url: '/brand/board/terms', id: 'brand064', name: Strings.termsManagement},
            termsEdit: {url: '/brand/board/terms/edit', id: 'brand066', name: Strings.termsManagement}
        },
        setting: {
            name: Strings.setting,
            member: {url: '/brand/setting/member', id: 'brand071', name: Strings.memberManagement},
            memberEdit: {url: '/brand/setting/member/edit', id: 'brand072', name: Strings.memberManagement},
            storage: {url: '/brand/setting/storage', id: 'brand074', name: Strings.fileStorage}
        }
    },
    cafe: {
        dashboard: {
            url: '/cafe/dashboard',
            id: 'cafe001',
            name: Strings.dashboard,
            notice: {url: '/cafe/dashboard/notice', id: 'cafe002', name: Strings.notice},
            manual: {url: '/cafe/dashboard/manual', id: 'cafe003', name: Strings.usageManual},
        },
        contents: {
            name: Strings.contentsManagement,
            orderKiosk: {url: '/cafe/contents/orderKiosk', id: 'cafe011', name: Strings.orderKiosk},
            orderKioskEdit: {url: '/cafe/contents/orderKiosk/edit', id: 'cafe012', name: Strings.orderKiosk},
            pickupBoard: {url: '/cafe/contents/pickupBoard', id: 'cafe013', name: Strings.pickupBoard},
            pickupBoardEdit: {url: '/cafe/contents/pickupBoard/edit', id: 'cafe014', name: Strings.pickupBoard}
        },
        product: {
            name: Strings.productManagement,
            base: {url: '/cafe/product', id: 'cafe021', name: Strings.productManagement},
            display: {url: '/cafe/product/display', id: 'cafe024', name: Strings.productDisplayManagement},
            manage: {url: '/cafe/product/manage', id: 'cafe025', name: Strings.productManagement},
            manageList: {url: '/cafe/product/manage-list', id: 'cafe025', name: Strings.productManagement},
            category: {url: '/cafe/product/category', id: 'cafe022', name: Strings.categoryManagement},
            option: {url: '/cafe/product/option', id: 'cafe023', name: Strings.optionManagement},
            optionNew: {url: '/cafe/product/option/new', id: 'cafe029', name: Strings.optionManagement},
            optionEdit: {url: '/cafe/product/option/edit', id: 'cafe026', name: Strings.optionManagement},
            stock: {url: '/cafe/product/stock', id: 'cafe027', name: Strings.stockManagement},
            stockEdit: {url: '/cafe/product/stock/edit', id: 'cafe028', name: Strings.stockManagement},
        },
        sale: {
            name: Strings.salesManagement,
            base: {url: '/cafe/sale', id: 'cafe031', name: Strings.salesStatistics},
            business: {url: '/cafe/sale/business', id: 'cafe032', name: Strings.businessStatistics},
            selling: {url: '/cafe/sale/selling', id: 'cafe033', name: Strings.productSalesStatistics},
            manual: {url: '/cafe/sale/manual', id: 'cafe034', name: Strings.manualSalesManagement}
        },
        saleV2: {
            name: Strings.salesManagement + (CONSTANTS.SHOW_IN_DEV ? ' (V2)' : ''),
            base: {url: '/cafe/saleV2', id: 'cafe031_2', name: Strings.salesStatistics},
            business: {url: '/cafe/saleV2/business', id: 'cafe032_2', name: Strings.businessStatistics},
            selling: {url: '/cafe/saleV2/selling', id: 'cafe033_2', name: Strings.productSalesStatistics}
        },
        coupon: {
            name: Strings.pointSystem,
            base: {url: '/cafe/coupon', id: 'cafe041', name: Strings.couponManagement},
            stamp: {url: '/cafe/coupon/stamp', id: 'cafe042', name: Strings.stampManagement},
            use: {url: '/cafe/coupon/use', id: 'cafe043', name: Strings.useStatistics}
        },
        setting: {
            name: Strings.setting,
            business: {url: '/cafe/setting/business', id: 'cafe051', name: Strings.businessManagement},
            device: {url: '/cafe/setting/device', id: 'cafe052', name: Strings.deviceManagement},
            member: {url: '/cafe/setting/member', id: 'cafe053', name: Strings.memberManagement},
            memberEdit: {url: '/cafe/setting/member/edit', id: 'cafe054', name: Strings.memberManagement},
            storage: {url: '/cafe/setting/storage', id: 'cafe055', name: Strings.fileStorage}
        }
    },
    dining: {
        dashboard: {
            url: '/dining/dashboard',
            id: 'dining001',
            name: Strings.dashboard,
            notice: {url: '/dining/dashboard/notice', id: 'dining002', name: Strings.notice},
            manual: {url: '/dining/dashboard/manual', id: 'dining003', name: Strings.usageManual},
        },
        contents: {
            name: Strings.contentsManagement,
            orderKiosk: {url: '/dining/contents/orderKiosk', id: 'dining011', name: Strings.orderKiosk},
            orderKioskEdit: {url: '/dining/contents/orderKiosk/edit', id: 'dining012', name: Strings.orderKiosk},
            menuBoard: {url: '/dining/contents/menuBoard', id: 'dining013', name: Strings.menuBoard},
            menuBoardEdit: {url: '/dining/contents/menuBoard/edit', id: 'dining014', name: Strings.menuBoard},
            wayFinding: {url: '/dining/contents/wayFinding', id: 'dining015', name: Strings.wayFinding},
            wayFindingEdit: {url: '/dining/contents/wayFinding/edit', id: 'dining016', name: Strings.wayFinding},
            ticket: {url: '/dining/contents/ticket', id: 'dining017', name: Strings.mealTicketKiosk},
            ticketEdit: {url: '/dining/contents/ticket/edit', id: 'dining018', name: Strings.mealTicketKiosk},
            satisfaction: {url: '/dining/contents/satisfaction', id: 'dining019', name: Strings.satisfactionKiosk},
            satisfactionEdit: {
                url: '/dining/contents/satisfaction/edit',
                id: 'dining020',
                name: Strings.satisfactionKiosk
            },
        },
        diet: {
            name: Strings.dietManagement,
            menu: {url: '/dining/diet/menu', id: 'dining021', name: Strings.menuManagement},
            course: {url: '/dining/diet/course', id: 'dining022', name: Strings.courseManagement},
            courseEdit: {url: '/dining/diet/course/edit', id: 'dining022', name: Strings.courseManagement},
            operation: {url: '/dining/diet/operation', id: 'dining023', name: Strings.operationTimeManagement},
            operationEdit: {url: '/dining/diet/operation/edit', id: 'dining024', name: Strings.operationTimeManagement}
        },
        meal: {
            name: Strings.mealQuantityReservationManagement,
            setting: {url: '/dining/meal/setting', id: 'dining031', name: Strings.mealQuantityReservationManagement},
            reservation: {url: '/dining/meal/reservation', id: 'dining032', name: Strings.reservationListManagement}
        },
        sale: {
            name: Strings.salesManagement,
            base: {url: '/dining/sale', id: 'dining041', name: Strings.salesStatistics},
            order: {url: '/dining/sale/order', id: 'dining042', name: Strings.salesStatistics},
            business: {url: '/dining/sale/business', id: 'dining043', name: Strings.businessStatistics},
            manual: {url: '/dining/sale/manual', id: 'dining044', name: Strings.manualSalesManagement},
            manualDetail: {url: '/dining/sale/manual/detail', id: 'dining045', name: Strings.manualSalesManagement},
        },
        saleV2: {
            name: Strings.salesManagement + (CONSTANTS.SHOW_IN_DEV ? ' (V2)' : ''),
            base: {url: '/dining/saleV2', id: 'dining041_2', name: Strings.salesStatistics},
            order: {url: '/dining/saleV2/order', id: 'dining042_2', name: Strings.paymentManagement},
            business: {url: '/dining/saleV2/business', id: 'dining043_2', name: Strings.businessStatistics},
            unsettledSales: {url: '/dining/saleV2/unsettledSales', id: 'dining044_2', name: Strings.unsettledSales},
        },
        coupon: {
            name: Strings.pointSystem,
            base: {url: '/dining/coupon', id: 'dining051', name: Strings.couponManagement},
            stamp: {url: '/dining/coupon/stamp', id: 'dining052', name: Strings.stampManagement},
            use: {url: '/dining/coupon/use', id: 'dining053', name: Strings.useStatistics}
        },
        satisfaction: {
            name: Strings.satisfactionManagement,
            setting: {url: '/dining/satisfaction/setting', id: 'dining061', name: Strings.satisfactionSetting},
            app: {url: '/dining/satisfaction/app', id: 'dining062', name: Strings.satisfactionSettingApp},
            statistics: {url: '/dining/satisfaction/statistics', id: 'dining063', name: Strings.satisfactionStatistics},
            statisticsApp: {
                url: '/dining/satisfaction/statisticsApp',
                id: 'dining064',
                name: Strings.satisfactionStatisticsApp
            },
        },
        setting: {
            name: Strings.setting,
            business: {url: '/dining/setting/business', id: 'dining071', name: Strings.businessManagement},
            device: {url: '/dining/setting/device', id: 'dining072', name: Strings.deviceManagement},
            member: {url: '/dining/setting/member', id: 'dining073', name: Strings.memberManagement},
            memberEdit: {url: '/dining/setting/member/edit', id: 'dining074', name: Strings.memberManagement},
            storage: {url: '/dining/setting/storage', id: 'dining075', name: Strings.fileStorage}
        }
    },
    my: {
        menu: {url: '/my/menu', id: 'my081', name: Strings.myMenu},
        shop: {url: '/my/shop', id: 'my082', name: Strings.myShop}
    },
    common: {
        notice: {url: '/common/notice', id: 'common091', name: Strings.notice}
    }
};
